import { memo } from "react";

import BaseNumericInput from "./BaseNumericInput";

function formatCompact(value) {
  const number = Number(value) || 0;

  if (number >= 10000000) return `₹${(number / 10000000).toFixed(2)} Cr`;
  if (number >= 100000) return `₹${(number / 100000).toFixed(2)} L`;
  if (number >= 1000) return `₹${(number / 1000).toFixed(1)} K`;

  return `₹${number.toLocaleString("en-IN")}`;
}

function CurrencyInput(props) {
  return (
    <div className="space-y-2">
      <BaseNumericInput
        {...props}
        formatter={(value) =>
          value === "" || value === null || value === undefined
            ? ""
            : Number(value).toLocaleString("en-IN")
        }
        parser={(value) =>
          Number(String(value).replace(/,/g, ""))
        }
        inputMode="numeric"
      />

      <div className="flex justify-between text-xs text-muted-foreground">
        <span>{formatCompact(props.value)}</span>
        <span>
          {(props.step ?? 1).toLocaleString("en-IN")} step
        </span>
      </div>
    </div>
  );
}

export default memo(CurrencyInput);